import { z } from 'zod';

export const searchSchema = z.object({
  ma_ngv: z.string().optional(),
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  tk: z.string().optional(),
  dien_giai: z.string().optional(),
  ma_kh: z.string().optional(),
  tk_no: z.string().optional(),
  ma_unit: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional(),
  dynamic_filters: z.record(z.unknown()).optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  ma_ngv: '',
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  tk: '',
  dien_giai: '',
  ma_kh: '',
  tk_no: '',
  ma_unit: '',
  status: '',
  user_id0: ''
};

export const formSchema = z.object({
  ma_ngv: z.string().min(1, 'Loại chứng từ là bắt buộc'),
  dia_chi: z.string().optional(),
  ong_ba: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  transfer_yn: z.boolean().optional(),
  so_ct: z.string().optional(),
  ngay_ct: z.string().min(1, 'Ngày chứng từ là bắt buộc'),
  ngay_lct: z.string().min(1, 'Ngày lập là bắt buộc'),
  ma_nt: z.string().optional().nullable(),
  ty_gia: z.coerce.number().optional().nullable(),
  hd_yn: z.boolean().optional().nullable(),
  so_ct0: z.string().optional().nullable(),
  ngay_ct0: z.string().optional().nullable(),
  tg_dd: z.boolean().optional().nullable(),
  loai_lenh: z.string().optional().nullable(),
  stk_kh: z.string().optional().nullable(),
  ten_kh: z.string().optional().nullable(),
  chi_nhanh_nh: z.string().optional().nullable(),
  tinh_thanh_nh: z.string().optional().nullable(),
  dien_giai_nh: z.string().optional().nullable(),
  phi_nhan_yn: z.boolean().optional().nullable(),
  so_ct_goc: z.coerce.number().optional().nullable(),
  dien_giai_ct_goc: z.string().optional().nullable()
  // t_tien_nt: z.coerce.number().optional(),
  // t_thue_nt: z.coerce.number().optional(),
  // t_cp_nt: z.coerce.number().optional(),
  // t_tt_nt: z.coerce.number().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_ngv: '1',
  so_ct: '',
  ngay_ct: new Date().toISOString().split('T')[0],
  ngay_lct: new Date().toISOString().split('T')[0],
  dia_chi: '',
  ong_ba: '',
  dien_giai: '',
  ma_nt: '',
  ty_gia: 1,
  status: '0',
  transfer_yn: false,
  hd_yn: false,
  tg_dd: false,
  phi_nhan_yn: false,
  loai_lenh: '1',
  stk_kh: '',
  ten_kh: '',
  chi_nhanh_nh: '',
  tinh_thanh_nh: '',
  dien_giai_nh: '',
  so_ct_goc: 0,
  dien_giai_ct_goc: '',
  so_ct0: '',
  ngay_ct0: new Date().toISOString().split('T')[0]
  // t_tien_nt: 0,
  // t_thue_nt: 0,
  // t_cp_nt: 0,
  // t_tt_nt: 0
};
